import { axios } from "../lib/axios";

export const getSlots = async function (
  serviceId,
  startDate,
  endDate,
  serviceProviderId
) {
  try {
    const response = await axios.get("booking/getslots", {
      header: { "Content-Type": "application/json" },
      params: {
        serviceId: serviceId,
        startDate: startDate,
        endDate: endDate,
        serviceProviderId: serviceProviderId,
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getOpenTimeSlots = async function (
  serviceId,
  startDate,
  endDate,
  serviceProviderId
) {
  try {
    const response = await axios.get("booking/getopenslots", {
      header: { "Content-Type": "application/json" },
      params: {
        serviceId: serviceId,
        startDate: startDate,
        endDate: endDate,
        serviceProviderId: serviceProviderId,
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getReservedTimeSlots = async function (
  serviceId,
  startDate,
  endDate,
  serviceProviderId
) {
  try {
    const response = await axios.get("booking/getreservedslots", {
      header: { "Content-Type": "application/json" },
      params: {
        serviceId: serviceId,
        startDate: startDate,
        endDate: endDate,
        serviceProviderId: serviceProviderId,
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getAllDailySchedule = async function (model) {
  try {
    const response = await axios.get("settings/getalldailyschedule", {
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const addDailySchedule = async function (model) {
  try {
    const response = await axios.post("settings/adddailyschedule", model, {
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateDailySchedule = async function (model) {
  try {
    const response = await axios.post("settings/updatedailyschedule", model, {
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const deleteDailySchedule = async function (id) {
  try {
    await axios.delete("settings/deletedailyschedule", { data: { id: id } });
  } catch (error) {
    return error.response;
  }
};

export const addServiceProviderSchedule = async function (model) {
  try {
    const response = await axios.post(
      "booking/upsertserviceproviderschedule",
      model,
      { header: { "Content-Type": "application/json" } }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
export const deleteServiceProviderSchedule = async function (model) {
  try {
    await axios.delete("booking/deleteserviceproviderschedule", {
      data: model,
    });
  } catch (error) {
    return error.response;
  }
};
export const addAppointment = async function (
  serviceProviderId,
  appointmentDateTime,
  userId,
  userName
) {
  try {
    const response = await axios.post("booking/addappointment", {
      header: { "Content-Type": "application/json" },
      params: {
        serviceProviderId: serviceProviderId,
        appointmentDateTime: appointmentDateTime,
        userId: userId,
        userName: userName,
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
